"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLineupsConfig = void 0;
const merge_1 = __importDefault(require("lodash/merge"));
const defaultConfig = {
    filters: [],
    table: { columns: [] },
    lineupSizes: undefined,
    sealedSearch: undefined,
    typeOptions: { face: true, smt: true }
};
function createLineupsConfig(config) {
    // merge the default config with the provided values
    return merge_1.default({}, defaultConfig, config);
}
exports.createLineupsConfig = createLineupsConfig;
//# sourceMappingURL=lineups-partial.js.map